import Joi from "joi";
import FormValidationResult from "../../../../../common/utils/validation/types/form-validation-result";
import formValidationService from "../../../../../common/utils/validation/form-validation.service";
import DriverAddAddressType from "../../add/common/types/driver-add-address-type";
import DriverAddressFormTypeSelectOption from "./types/driver-address-form-type-select-option";

const validateAddressType = (
  addressTypeSelectOption: DriverAddressFormTypeSelectOption | null
): FormValidationResult => {
  const validValues = Object.values(DriverAddAddressType);

  const validationSchema = Joi.string()
    .valid(...validValues)
    .required();

  const addressType = addressTypeSelectOption?.value;

  return formValidationService.validate(addressType, validationSchema);
};

const validateStreet = (street: string): FormValidationResult => {
  const validationSchema = Joi.string().min(2).max(50).required();

  return formValidationService.validate(street, validationSchema);
};

const validateHouseNumber = (houseNumber: string): FormValidationResult => {
  const validationSchema = Joi.string().max(10).trim().required();

  return formValidationService.validate(houseNumber, validationSchema);
};

const validateApartmentNumber = (
  apartmentNumber: string
): FormValidationResult => {
  const validationSchema = Joi.string().allow("").max(10).trim();

  return formValidationService.validate(apartmentNumber, validationSchema);
};

const validateTown = (town: string): FormValidationResult => {
  const validationSchema = Joi.string().min(2).max(50).trim().required();

  return formValidationService.validate(town, validationSchema);
};

const validateCountry = (country: string): FormValidationResult => {
  const validationSchema = Joi.string().min(2).max(50).trim().required();

  return formValidationService.validate(country, validationSchema);
};

const validateZipCode = (zipCode: string): FormValidationResult => {
  const validationSchema = Joi.string().min(2).max(10).trim().required();

  return formValidationService.validate(zipCode, validationSchema);
};

const validateDescription = (description: string): FormValidationResult => {
  const validationSchema = Joi.string().allow("").max(100).trim();

  return formValidationService.validate(description, validationSchema);
};

const driverAddressFormValidationService = {
  validateAddressType,
  validateStreet,
  validateHouseNumber,
  validateApartmentNumber,
  validateTown,
  validateCountry,
  validateZipCode,
  validateDescription,
};

export default driverAddressFormValidationService;
